<template>
    <div class="ai-answer page-cont">
        <div class="answer-tit">
            <h2>中医药智能问答</h2>
            <p>基于大模型技术，为您提供中医药问题答案，快来问我吧!</p>
        </div>
        <div class="answer-info">
            <div class="info-list" id="info-list">
                <div
                    v-for="(item, index) in list" 
                    class="list"
                    :key="index"
                    > 
                    <!-- 1.我方头像 --> 
                    <div v-if="index%2===0"  class="list-answer">
                        <div class="icon"></div>
                        <div class="cont">
                            <div class="txt" v-if="index==list.length-1&&isAnswer&&!item.val">
                                <i class="el-icon-loading"></i> 思索中，请您耐心等待......
                            </div>
                            <div class="txt" v-else>
                                <VueMarkdown :source="item.val" ></VueMarkdown>
                                <span v-if="item.isStreaming" class="streaming-loading">
                                    <i class="el-icon-loading"></i>
                                </span>
                            </div>
                            <p>{{item.timer}}</p>
                        </div>

                    </div>
                    <!-- 2.对方内容 --> 
                    <div v-else class="list-user">
                        <div class="cont">
                            <div class="txt">{{item.val}}</div>
                            <p>{{item.timer}}</p>
                        </div>
                        <div class="icon"></div> 
                    </div> 
                </div> 
            </div>
            <div class="recorded">
                <!-- @keydown.enter.native="send" -->
                <el-input type='textarea' v-model="question" :rows="3"  :cols="4"  class="problem"  placeholder="请输入您的问题，[Ctrl+Enter]换行，[enter]发送" @keydown.native="handleKeyCode($event)"></el-input>
                <div  class="send" >
                    <el-button v-if="list.length>2" :disabled="isAnswer" type="success" @click="refresh_clcik" >新对话</el-button>
                    <el-button type="primary" @click="send" :disabled="isAnswer">发送</el-button>
                </div>
            </div>
            <div class="such">
                <p class="such-label">您可以这样问我：</p>
                <ul class="such-list">
                    <li @click="such_click(item)" v-for="(item,index) in suchList" :key="index">
                        <span>{{ item.val }}</span>
                    </li> 
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import {questionsAnswers,getRandomId} from '../../io/api.js'
import formDates from '../../utils/formDate.js'
import {getRealTime} from '../../utils/getRealTime.js'
export default {
    components: {VueMarkdown},
    data() {
        return {
            list:[
                {val:'欢迎使用中医智能问答！我是由中国中医科学院中医药信息研究所开发的智能助手，致力于为您提供专业的中医知识。简要描述您的问题，帮您推荐适合的中医方法。',timer:getRealTime()}, 
            ],
            suchList:[
                {val:'感冒了吃什么药?'},
                {val:'人参有哪些功效?'},
                {val:'附子汤由哪些中药组成?'},
                {val:'立春吃什么?'},
                {val:'太极拳怎么练?'},
                {val:'路志正医师简介'},
            ],
            question:'',
            chatId:'',
            isAnswer:false,
        }
    },
    watch: {},
    mounted() {
        this.getChatId();
    },
    methods: {
        getChatId(){
            getRandomId().then(res=>{
                let data = res.data;  
                if(data.code==0){
                    this.chatId=data.data.chatId||'';
                }else{
                    this.$message.error(data.msg||'请求失败～');
                }
            })
        },
        send(){  
            if (this.isAnswer) return
            if(this.question==''){
                this.$message.error('请输入您的问题～');
                return
            }
            this.isAnswer=true;   
            let arr=[
                {
                    val:this.question,
                    timer:getRealTime(),
                },
                {
                    val:'',
                    timer:'',
                    isStreaming: false, // 标记是否正在流式输出
                }
            ]
            this.list=[...this.list,...arr];
            this.scrollToBottom(); 

            // 流式接收答案
            const answerIndex = this.list.length - 1;
            let fullAnswer = '';
            let params = { 
                type: "1",
                questions: this.question,
                chatId:this.chatId,
            }
            // 设置流式输出状态
            this.$set(this.list[answerIndex], 'isStreaming', true);
            questionsAnswers(
                params,
                // onMessage: 接收到流式数据
                (data) => { 
                    // 根据后端返回的数据结构解析内容
                    let chunk = '';
                    // 优先处理 OpenAI 风格的流式响应格式
                    // 格式: {choices: [{delta: {content: "..."}}]}
                    if (data.choices && Array.isArray(data.choices) && data.choices.length > 0) {
                        const choice = data.choices[0];
                        if (choice.delta && choice.delta.content !== undefined) {
                            // 获取增量内容（可能是字符串或空字符串）
                            chunk = choice.delta.content || ''; 
                            if (chunk) {
                                fullAnswer += chunk;
                            }
                        }
                    } 
                    // // 处理其他数据格式（兼容性）
                    // else if (data.data && data.data.replyResult) {
                    //     // 如果后端返回的是完整结构 {data: {replyResult: {data: "..."}}}
                    //     const replyData = data.data.replyResult.data;
                    //     if (replyData !== undefined && replyData !== null) {
                    //         // 如果是完整答案，直接替换；如果是增量，则追加
                    //         if (typeof replyData === 'string') {
                    //             // 判断是完整答案还是增量
                    //             if (replyData.length > fullAnswer.length && replyData.startsWith(fullAnswer)) {
                    //                 // 增量更新
                    //                 chunk = replyData.substring(fullAnswer.length);
                    //                 fullAnswer = replyData;
                    //             } else {
                    //                 // 完整替换
                    //                 fullAnswer = replyData;
                    //             }
                    //         } else {
                    //             chunk = String(replyData);
                    //             fullAnswer += chunk;
                    //         }
                    //     }
                    // } else if (data.text) {
                    //     // 如果是纯文本流 {text: "..."}
                    //     chunk = data.text;
                    //     fullAnswer += chunk;
                    // } else if (data.content) {
                    //     // 如果直接是 content 字段 {content: "..."}
                    //     chunk = data.content;
                    //     fullAnswer += chunk;
                    // } else if (typeof data === 'string') {
                    //     // 如果直接是字符串
                    //     chunk = data;
                    //     fullAnswer += chunk;
                    // }
                    // 实时更新显示（只要有内容更新就刷新）
                    if (chunk !== undefined) {
                        // console.log(chunk,'===chunk===',new Date().getTime());
                        // console.log(fullAnswer,'===fullAnswer===');
                        // 使用 Vue.set 确保响应式更新
                        this.$set(this.list[answerIndex], 'val', fullAnswer);
                        // 保持流式输出状态
                        this.$set(this.list[answerIndex], 'isStreaming', true);
                        // 强制触发视图更新
                        this.$nextTick(() => {
                            this.scrollToBottom();
                        });
                    }
                },
                // onError: 错误处理
                (error) => {
                    this.isAnswer = false;
                    this.$set(this.list[answerIndex], 'timer', getRealTime());
                    // 移除流式输出状态
                    this.$set(this.list[answerIndex], 'isStreaming', false);
                    this.$set(this.list[answerIndex], 'val', '请求失败，请稍后重试～');
                    console.error('流式请求错误:', error);
                    this.$message.error('请求失败，请稍后重试～');
                    // 如果出错，移除空的答案项
                    if (!this.list[answerIndex].val) {
                        this.list.splice(answerIndex, 1);
                    }
                },
                // onComplete: 完成处理
                () => {
                    this.isAnswer = false;
                    // 移除流式输出状态
                    this.$set(this.list[answerIndex], 'isStreaming', false);
                    // 确保最终答案已更新
                    if (fullAnswer) { 
                        this.$set(this.list[answerIndex], 'timer', getRealTime());
                        this.$set(this.list[answerIndex], 'val', fullAnswer);
                    }
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                }
            );
            
            this.question='';
        },
        refresh_clcik(){
            this.getChatId();
            this.list=[
                {val:'欢迎使用中医智能问答！我是由中国中医科学院中医药信息研究所开发的智能助手，致力于为您提供专业的中医知识。简要描述您的问题，帮您推荐适合的中医方法。',timer:getRealTime()}, 
            ];
            this.question='';
            this.isAnswer=false;
        },
        handleKeyCode(e){
            if (e.keyCode == 13) {
                if (!e.ctrlKey) {
                    this.send() 
                    e.preventDefault()
                } else {
                    this.question += "\n";
                }
            }
        },
        such_click(item){
            this.question=item.val; 
        },
        // 定义将滚动条定位在底部的方法
        scrollToBottom(){
            this.$nextTick(()=>{
            let info = this.$el.querySelector("#info-list")
                info.scrollTop = info.scrollHeight
            })
        },
         // 时间转换
        formDate(date, day = "yyyy-MM-dd h:m:s") {
            return formDates(date, day)
        },
    }
}
</script>
<style lang='less' scoped>
.ai-answer{
    box-shadow:0px 3px 12px 0px #c4bfbc;// 0 2px 10px 0px rgba(0, 0, 0, .1);   
    border-radius: 8px;
    overflow: hidden;
    width: 1000px; 
    .answer-tit{
        width: 100%;
        padding: 50px;
        height: 160px;
        background: url('../../assets/images/tit-bg.jpg') no-repeat;
        background-size: cover;
        text-align: center;
        color: #fff;
        line-height: 40px;
        font-size: 16px;
        h2{
            font-size: 28px;
        }
    }
    .answer-info{
        width: 100%;
        padding-bottom: 20px;
        .info-list{ 
            height: 340px;
            overflow-y: auto;
            padding:20px; 
            /* padding-right: 2%; */
            font-size: 14px;
            border-bottom: 1px solid #ccc;
            .list {
                position: relative;
                margin-bottom: 20px;
                >div{
                    width:750px ;
                }
                .icon{
                    display: inline-block;
                    width: 34px;
                    height: 34px; 
                    
                }
                .cont{
                    // max-width: 700px;
                    .txt{
                        border-radius: 6px; 
                        padding: 10px;
                        margin-bottom: 8px; 
                        line-height: 24px;
                        display: inline-block;
                        position: relative;
                        .streaming-loading{
                            display: inline-block;
                            margin-left: 4px;
                            vertical-align: middle;
                            i{
                                animation: rotating 1s linear infinite;
                            }
                        }
                    }
                }
                 
            }
            .list-answer{
                display: flex; 
                .icon{
                    flex-shrink: 0;
                    margin-right: 10px;
                   background: url('../../assets/images/favicon.png') no-repeat;
                   background-size: 100%;
                }
                .txt{ 
                    background: #ececec;
                }
            }
            .list-user{ 
                margin-left: auto; 
                display: flex;
                justify-content: flex-end;
                // p{
                //     text-align: right;
                // }
                .cont{
                    text-align: right;
                }
                .icon{
                    flex-shrink: 0;
                    margin-left: 10px;
                    background: url('../../assets/images/user.png') no-repeat;
                    background-size: 100%;
                }
                .txt{ 
                    background: #396de7;
                    color: #fff;
                }
            }
        } 
       .recorded {
            padding: 20px 20px 10px;
            position: relative;
            height: 140px;
            .problem {
                // height: 68px;
                // width: 100%; 
                padding: 10px;
                font-size: 14px;
                outline: none;
                border-color: #396de7;
                border-radius: 6px;
                ::v-deep .el-textarea__inner {  
                    resize: none;  
                }
            }
            .send {
                margin-left: auto; 
                margin-right: 10px;   
                text-align: right;
                color: #fff;
                // cursor: pointer;
            }
        }
        .such{
            padding: 0 30px;
            .such-label {
                margin-bottom: 10px;
            }
            .such-list{
                display: flex;
                flex-wrap: wrap;
                width: 750px;
                li{
                    width: 240px;
                    margin-right: 10px;
                    line-height: 24px;
                    margin-bottom: 10px;
                    span{
                        cursor: pointer;
                    }
                }
                
            }
        }
    }
}
@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>